module.exports = __webpack_public_path__ + "static/media/lucao.a3784255.jpg";